module.exports = __webpack_public_path__ + "images/category_lp/car/store_images/4_c116b9813e0bc79039e1a1ed6e39e870.png";